import React from 'react';
import { FinanceOperationsEditReasonForm } from 'entities/financeOperations/ui/FinanceOperationsEditReasonForm';
import { IFinanceOperatorsItem, PartialDowntime } from 'entities/financeOperations/types';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useUpdateFinanceOperatorReasonDefaultValue } from 'entities/financeOperations/lib';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { useUpdateReasonMutation } from 'entities/financeOperations/api/updateFinanceOperatorReasonApi';
import { useDispatch } from 'react-redux';

type FinanceOperationsEditReasonPropsType = {
  data: IFinanceOperatorsItem;
};
export const UploadFinanceOperationsEditReason = ({ data }: FinanceOperationsEditReasonPropsType) => {
  const dispatch = useDispatch();
  const defaultValues = useUpdateFinanceOperatorReasonDefaultValue(data);
  const editReasonForm = useForm<PartialDowntime>({
    defaultValues,
  });
  const [updateReason] = useUpdateReasonMutation();

  const onSubmit: SubmitHandler<PartialDowntime> = (itemData) => {
    updateReason({ id: data.downtime.id, data: itemData }).then(() => {
      dispatch(setDrawerOpen(false));
    });
  };

  return (
    <FinanceOperationsEditReasonForm
      form={editReasonForm}
      onSubmit={onSubmit}
    />
  );
};
